import { getRelativeImagePath } from "./getRelativeImagePath";

export function getThumbImage(imageObj, isWebpImage, restProps = {}) {
  const { isMerchProduct } = restProps;

  if (isMerchProduct) {
    return getRelativeImagePath(`/img/ds/${imageObj}`);
  }
  if (isWebpImage) {
    return getRelativeImagePath(`/img/th/${imageObj}`);
  }
  if (typeof imageObj === "string") {
    return getRelativeImagePath(`/${process.env.NEXT_PUBLIC_THUMBNAILS_IMAGE_PATH}/${imageObj}`);
  }
  if (imageObj && imageObj.type === "a") {
    return imageObj.url;
  }
  if (imageObj && imageObj.type === "r") {
    return `${process.env.NEXT_PUBLIC_ROOT_URL}/${process.env.NEXT_PUBLIC_THUMBNAILS_IMAGE_PATH}/${imageObj.url}`;
  }
  return null;
}
